import Vue from 'vue'
import Payment from './Payment.vue'
import PaymentHistory from './PaymentHistory.vue'
import EditPayment from './EditPayment.vue'
import PayPayment from './PayPayment.vue'
import ChangeCard from './ChangeCardPayment.vue'
import PaymentConciliation from './PaymentConciliation.vue'
import PaymentConciliationProcess from './PaymentConciliationProcess.vue'
// import GroupPayment from './GroupPayment.vue'
// import GroupPaymentView from './GroupPaymentView.vue'
// import RevertPayment from './RevertPayment.vue'
// import AddService from './AddServicePayment.vue'
// import MergePayment from './MergePayment.vue'
// import ChangeStatus from './ChangeStatusPayment.vue'

// const OpenGroupPaymentComponent = Vue.extend(GroupPayment)
// const OpenGroupPaymentViewComponent = Vue.extend(GroupPaymentView)
// const OpenRevertPaymentComponent = Vue.extend(RevertPayment)
// const OpenAddServiceComponent = Vue.extend(AddService)
// const MergePaymentComponent = Vue.extend(MergePayment)
// const ChangeStatusComponent = Vue.extend(ChangeStatus)

const OpenPaymentComponent = Vue.extend(Payment)
const OpenHistoryPaymentComponent = Vue.extend(PaymentHistory)
const OpenEditPaymentComponent = Vue.extend(EditPayment)
const OpenPayPaymentComponent = Vue.extend(PayPayment)
const ChangeCardComponent = Vue.extend(ChangeCard)
const OpenPaymentConciliationComponent = Vue.extend(PaymentConciliation)
const OpenPaymentConciliationProcessComponent = Vue.extend(PaymentConciliationProcess)
export default {
  openPayment (propsData) {
    return new OpenPaymentComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openHistoryPayment (propsData) {
    return new OpenHistoryPaymentComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openEditPayment (propsData) {
    return new OpenEditPaymentComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openPayPayment (propsData) {
    return new OpenPayPaymentComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openChangeCard (propsData) {
    return new ChangeCardComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openPaymentConciliation (propsData) {
    return new OpenPaymentConciliationComponent({
      el: document.createElement('div'),
      propsData
    })
  },
  openPaymentConciliationProcess (propsData) {
    return new OpenPaymentConciliationProcessComponent({
      el: document.createElement('div'),
      propsData
    })
  }
  // openPayPayment (propsData) {
  //   return new OpenPayPaymentComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // openGroupPayment (propsData) {
  //   return new OpenGroupPaymentComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // openGroupPaymentView (propsData) {
  //   return new OpenGroupPaymentViewComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // openRevertPayment (propsData) {
  //   return new OpenRevertPaymentComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // addService (propsData) {
  //   return new OpenAddServiceComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // mergePayment (propsData) {
  //   return new MergePaymentComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
  // openChangeStatus (propsData) {
  //   return new ChangeStatusComponent({
  //     el: document.createElement('div'),
  //     propsData
  //   })
  // },
}



// WEBPACK FOOTER //
// ./client/components/finances/V2/payment/payment.js